export default "__VITE_ASSET__BNgVkDYM__"